const DEFAULT_TOOLTIP_TITLE = 'Save as sample event';
const PERMISSIONS_DISABLED_TOOLTIP_TITLE = 'You do not have permission to create sample events';

export default function determineTooltipTitle({ canCreateSampleEvent, disabled, disabledMessage }) {
  if (!canCreateSampleEvent) {
    return PERMISSIONS_DISABLED_TOOLTIP_TITLE;
  }

  if (disabled && disabledMessage) {
    return disabledMessage;
  }

  if (disabled) {
    return null;
  }

  return DEFAULT_TOOLTIP_TITLE;
}
